import { TStore } from "@/messenger/types/store.types";

export const getUserInterfaceSelector = (state: TStore) => state.userInterface;
export const getChatFrameUISelector =(state: TStore) => getUserInterfaceSelector(state).chatFrame;